import { BuildingsIconComponent } from 'assets/icons/buildings';
import { Card } from 'antd';
import { CompanyForm } from './components/CompanyForm';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { HttpError } from '@refinedev/core';
import { ICompany } from 'interfaces/companies';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const CompanyEdit = () => {
  const { formProps, saveButtonProps } = useForm<
    ICompany,
    HttpError,
    ICompany
  >();

  return (
    <EditLayout title="Editar unidade" saveButtonProps={saveButtonProps}>
      <PageHeader
        title={formProps.initialValues?.name}
        icon={BuildingsIconComponent}
      />

      <Card>
        <CompanyForm formProps={formProps} />
      </Card>
    </EditLayout>
  );
};
